import { createTheme } from '@mui/material/styles';

const portfolioTheme = createTheme({
  palette:{
    primary: {
      main:'#1e4258',
    },
    secondary: {
      main:'#265077',
    },
    cube: '#494b68',
    cubeBG: '#2d5f5d',

    // success:,
    // mainBg:'#1e4258',
    textColor: '#FFF',
  },
  // accessibilityMode:{

  // },
});

export default portfolioTheme;